import cx from 'classnames';

const REPORT_SPAN: Record<number, string> = {
  1: '',
  2: 'lg:col-span-2',
  3: 'lg:col-span-3',
  4: 'lg:col-span-4',
};

/** The latest report takes whatever the other cards leave of the row, so a missing one leaves no gap. */
export const reportTileSpan = (hasIncidents: boolean, hasHealth: boolean): string =>
  cx(REPORT_SPAN[4 - (hasIncidents ? 1 : 0) - (hasHealth ? 2 : 0)], !hasIncidents && 'sm:col-span-2');
